module.exports = __webpack_public_path__ + "static/media/roo.cd351586.png";